import { LINE_POINTS } from './constants';

export const classes = {
  wrapper: 'grid grid-cols-[60px_1fr] grid-rows-[1fr_auto] h-full pt-3 pb-1',
  axis: 'flex flex-col justify-between items-end pr-3',
  axisLabel: 'h-0 flex items-center',
  plot: 'relative',
  gridlines: 'absolute inset-0 flex flex-col justify-between',
  gridline: 'border-t border-black/[0.06]',
  columns: 'absolute inset-0 flex items-end',
  column: 'flex-1 flex items-end justify-center gap-[3px] min-w-0 h-full',
  bar: 'w-[22px] rounded-b-none',
  lineArea: 'absolute inset-0',
  areaFill: 'absolute inset-0',
  stroke: 'absolute inset-0 w-full h-full overflow-visible',
  strokePath: 'fill-none stroke-black/[0.12] stroke-[3px]',
  labels: 'flex pt-2.5',
  label: 'flex-1 text-center text-taupe-1 text-[11px] font-medium',
};

export const styles = {
  areaFill: {
    clipPath: `polygon(0% 100%, ${LINE_POINTS.map(([x, y]) => `${x}% ${y}%`).join(', ')}, 100% 100%)`,
    maskImage: 'linear-gradient(to bottom, rgba(0,0,0,0.9), rgba(0,0,0,0.04))',
    WebkitMaskImage:
      'linear-gradient(to bottom, rgba(0,0,0,0.9), rgba(0,0,0,0.04))',
  },
};

export function buildSmoothPath(
  points: readonly (readonly [number, number])[]
) {
  return points
    .map(([x, y], i) => {
      if (i === 0) return `M ${x} ${y}`;
      const [px, py] = points[i - 1];
      const cx = (px + x) / 2;
      return `C ${cx} ${py}, ${cx} ${y}, ${x} ${y}`;
    })
    .join(' ');
}
